import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RootState } from "../../models/RootState";
import {
  setToken,
  setOperatorId,
  setPartnerId,
  setProviderId,
  setSapToken,
  setTheme,
  setLobby,
} from "../../store";
import { loadColorConfig } from "../../store/auth/authActions";

type StoreProps = {
  setLobby: Function;
  setToken: Function;
  setSapToken: Function;
  setOperatorId: Function;
  setPartnerId: Function;
  setProviderId: Function;
  setTheme: Function;
  loadColorConfig: Function;
};

const HomePage: React.FC<StoreProps> = (props) => {
  const {
    setToken,
    setSapToken,
    setOperatorId,
    setPartnerId,
    setProviderId,
    setTheme,
    setLobby,
    loadColorConfig
  } = props;

  const [searchParams] = useSearchParams();
  let navigate = useNavigate();

  useEffect(() => {
    const userApiToken = searchParams.get("user_api_token");
    const operatorId = searchParams.get("operatorId");
    const partnerId = searchParams.get("partnerId");
    const providerId = searchParams.get("providerId");
    const token = searchParams.get("token");
    const sapToken = searchParams.get("sapToken");
    const callBackUrl = searchParams.get("callBackUrl")
      ? searchParams.get("callBackUrl")
      : null;
    const lobbyType = searchParams.get("lobby")
      ? searchParams.get("lobby")
      : "lobby";
    const primary = searchParams.get("primary");
    const secondary = searchParams.get("secondary");
    const background = searchParams.get("background");
    const textColor = searchParams.get("textColor");
    const background1 = searchParams.get("background1");
    const theme = searchParams.get("theme");
    const sportId = searchParams.get("sportId");
    const eventId = searchParams.get("eventId");
    const themeId = searchParams.get("tid");

    if (theme) {
      setTheme(theme);
    }
    primary &&
      document.documentElement.style.setProperty("--primary", `#${primary}`);
    secondary &&
      document.documentElement.style.setProperty("--table-bg", `#${secondary}`);
    background &&
      document.documentElement.style.setProperty(
        "--background",
        `#${background}`
      );
    textColor &&
      document.documentElement.style.setProperty(
        "--text-color",
        `#${textColor}`
      );
    background1 &&
      document.documentElement.style.setProperty(
        "--sub-header-color",
        `#${background1}`
      );

    const premiumSports = {
      operatorId: operatorId,
      partnerId: partnerId,
      providerId: providerId,
      token: token,
      sapToken: sapToken,
    };

    sessionStorage.setItem("psAuthToken", token);
    sessionStorage.setItem("psOperatorId", operatorId);
    sessionStorage.setItem("psPartnerId", partnerId);
    sessionStorage.setItem("psProviderId", providerId);
    sessionStorage.setItem("psAuthSAPToken", sapToken);
    sessionStorage.setItem("lobbyType", lobbyType);
    sessionStorage.setItem("themeId", themeId);
    if (callBackUrl) sessionStorage.setItem("callBackUrl", callBackUrl);

    if (userApiToken) {
      sessionStorage.setItem(
        "user_api_token",
        userApiToken
      );
    }

    setToken(sapToken);
    setOperatorId(operatorId);
    setPartnerId(providerId);
    setProviderId(providerId);
    setSapToken(providerId);
    loadColorConfig();

    if (token) {
      if (lobbyType.toLowerCase()?.includes("premium") && sportId && eventId) {
        document.documentElement.className = "theme-light";
        navigate(`/premium/${providerId}/${sportId}/${eventId}`,{
          replace: true
        });
      } else {
        navigate("/lobby", { replace: true } );
      }
    }
  }, [searchParams]);

  return <></>;
};

const mapStateToProps = (state: RootState) => {
  return {
    loading: state.auth.loading,
    loggedIn: state.auth.loggedIn,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setToken: (token: string) => dispatch(setToken(token)),
    setSapToken: (token: string) => dispatch(setSapToken(token)),
    setOperatorId: (oid: string) => dispatch(setOperatorId(oid)),
    setPartnerId: (pid: string) => dispatch(setPartnerId(pid)),
    setProviderId: (pid: string) => dispatch(setProviderId(pid)),
    setTheme: (theme: string) => dispatch(setTheme(theme)),
    setLobby: (lobbyType: string) => dispatch(setLobby(lobbyType)),
    loadColorConfig: () => dispatch(loadColorConfig())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
